export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AML जांच"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["एक पता दर्ज करें और ब्लॉकचेन चुनें — हम एक त्वरित स्क्रीनिंग करेंगे।"])}
}